// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vuTb","colBig":"styles_colBig__2gnZj","colSmall":"styles_colSmall__jFeyO","shopifyNameWrapper":"styles_shopifyNameWrapper__3Z3RU"};